module.exports = __webpack_public_path__ + "img/transfer.57a76f39.svg";